module.exports = __webpack_public_path__ + "img/logo.c541aca1.jpg";